import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=533febfe&"
import script from "./ApplicantDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplicantDetail.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ApplicantDetail.vue?vue&type=style&index=0&id=533febfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports